"use client";

import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";
import parse from "html-react-parser";

type TermsAndConditionsModalProps = {
  open: boolean;
  title: string;
  content: string;
  checkboxLabel: string;
  confirmLabel: string;
  isChecked: boolean;
  onCheckedChange: (checked: boolean) => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
};

export function TermsAndConditionsModal({
  open,
  title,  
  content,
  checkboxLabel,
  confirmLabel,
  isChecked,
  onCheckedChange,
  onConfirm,
  isSubmitting = false,
}: TermsAndConditionsModalProps) {
  return (
    <Dialog open={open} onOpenChange={() => undefined}>
      <DialogContent
        showCloseButton={false}
        className="max-w-3xl bg-gradient-to-br from-gray-950 via-gray-900 to-black border border-gray-800/70 shadow-[0_0_40px_rgba(255,107,0,0.2)]"
      >
        <DialogHeader className="space-y-4">
          <DialogTitle className="text-xl font-bold text-white">
            {title}
          </DialogTitle>
        </DialogHeader>

        <ScrollArea className="max-h-[50vh] bg-black/40 border border-gray-800/60 p-2 text-sm leading-relaxed text-gray-200 shadow-inner">
          <div className="terms-content space-y-3 [&_h1]:text-lg [&_h1]:font-bold [&_h1]:text-white [&_h2]:text-base [&_h2]:font-semibold [&_h2]:text-white [&_h3]:text-sm [&_h3]:font-semibold [&_h3]:text-white [&_p]:text-justify [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:mb-1 [&_a]:text-orange-400 [&_a]:underline [&_strong]:text-white">
            {parse(content || "")}
          </div>
        </ScrollArea>

        <DialogFooter className=" block pt-2 border-t border-gray-800/60">
        <div className="w-full text-center">
          <label
            className={cn(
              "flex w-full items-start gap-3 p-3 transition-colors",
              "hover:border-orange-500/60"
            )}
          >
            <Checkbox
              checked={isChecked}
              onCheckedChange={(checked) => onCheckedChange(checked === true)}
              className="mt-1"
            />
            <span className="text-sm text-gray-200 leading-relaxed">
              {checkboxLabel}
            </span>
          </label>

        </div>
        <div className="w-full text-center">
          <Button
            type="button"
            onClick={onConfirm}
            disabled={!isChecked || isSubmitting}
            className="w-full sm:w-auto bg-gradient-to-r from-orange-500 via-orange-600 to-orange-700 hover:from-orange-600 hover:to-orange-800 disabled:from-gray-700 disabled:to-gray-800"
          >
            {isSubmitting ? (
              <span className="flex items-center gap-2">
                <span className="h-3 w-3 animate-spin rounded-full border-2 border-white border-t-transparent" />
                {confirmLabel}
              </span>
            ) : (
              confirmLabel
            )}
          </Button>

        </div>
          
          
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
